<template>
  <UIInputText v-model="actionValue" :size :disabled />
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { InputSize } from '@types'
import { TaggingRuleAction } from '../utils/types'

import { UIInputText } from '@ui/fields'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<TaggingRuleAction>({
  required: true,
})

const size = inject<InputSize>('size')

const actionValue = computed({
  get() {
    return modelValue.value.value || ''
  },
  set(value) {
    modelValue.value = {
      ...modelValue.value,
      value: value || '',
    }
  },
})
</script>
